export const SESSION_STORAGE_KEY = {
	ACCESS_TOKEN: "cakery.accessToken",
	ID_TOKEN: "cakery.idToken",
	REFRESH_TOKEN: "cakery.refreshToken",
	CAKE_APP_TEMP_EMAIL: "cakery.tempEmail",
};

export const USER_TYPE = {
	CUSTOMER: "customer",
	BAKERY: "bakery",
	ADMIN: "admin",
};

export const CAKE_FLAVORS = ["Chocolate", "Vanilla", "Strawberry", "Yellow"];
export const ICING_FLAVORS = ["Chocolate", "Vanilla", "Strawberry"];
export const CAKE_FILLINGS = ["Strawberry Jam"];
export const STORE_TIERS = ["1", "2", "3", "4", "5", "6"];
export const SHAPE_OPTIONS = ["Round", "Square", "Heart"];
